var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHandler = function SvgHandler(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "handler_svg__st0",
    d: "M13.63 24H12.2c-2.76 0-5-2.24-5-5v-7.47h11.43V19c0 2.76-2.23 5-5 5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "handler_svg__st0",
    d: "M17.6 13.57c-.55 0-1-.45-1-1V8.42c0-.55.45-1 1-1s1 .45 1 1v4.16c0 .55-.45.99-1 .99zM14.48 13.57c-.55 0-1-.45-1-1V6.34c0-.55.45-1 1-1s1 .45 1 1v6.23c0 .56-.45 1-1 1zM11.36 13.57c-.55 0-1-.45-1-1V4.38c0-.55.45-1 1-1s1 .45 1 1v8.19c0 .56-.45 1-1 1zM8.24 13.57c-.55 0-1-.45-1-1V6.34c0-.55.45-1 1-1s1 .45 1 1v6.23c0 .56-.44 1-1 1zM8.3 21.88l-5.16-8.11c-.66-1.03.83-2.12 1.61-1.18l6.19 7.35c1.43 1.79-1.36 3.85-2.64 1.94z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "handler_svg__st0",
    d: "M19.97 5.6C18.33 2.76 15.27 1 12 1S5.67 2.76 4.03 5.6l-.87-.5C4.98 1.95 8.37 0 12 0s7.02 1.95 8.84 5.1l-.87.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "handler_svg__st0",
    d: "M4.89 6.26h-1.9c-.28 0-.5-.22-.5-.5V3.71c0-.28.22-.5.5-.5s.5.22.5.5v1.55h1.4c.28 0 .5.22.5.5s-.22.5-.5.5zM21.01 6.26h-1.9c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h1.4V3.71c0-.28.22-.5.5-.5s.5.22.5.5v2.05c0 .27-.22.5-.5.5z"
  })));
};
export default SvgHandler;